import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNeo4jComponent } from './simple-icons-neo4j.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNeo4jComponent ],
    exports:      [ SimpleIconsNeo4jComponent ],
    bootstrap:    []
})
export class SimpleIconsNeo4jModule {}
